'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function equalsFactory(target) {
  function equals(_ref) {
    var path = _ref.path,
        resolve = _ref.resolve;

    if (!resolve.isTag(target, 'state', 'props', 'module')) {
      throw new Error('Cerebral operator.equals: You have to use the STATE, PROPS or MODULE tag as first argument');
    }

    var targetValue = resolve.value(target);

    return path[targetValue] ? path[targetValue]() : path.otherwise();
  }

  equals.displayName = 'operator.equals(' + String(target) + ')';

  return equals;
}

exports.default = equalsFactory;
//# sourceMappingURL=equals.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/operators/equals.js
// module id = 267
// module chunks = 0